export const zeroState = (n) =>
  Array(2 ** n)
    .fill({ re: 0, im: 0 })
    .map((_, i) => (i === 0 ? { re: 1, im: 0 } : { re: 0, im: 0 }));

export const H = [
  [1 / Math.sqrt(2), 1 / Math.sqrt(2)],
  [1 / Math.sqrt(2), -1 / Math.sqrt(2)],
];
export const X = [
  [0, 1],
  [1, 0],
];

export const applySingleQubitGate = (state, nQubits, target, gate) => {
  const newState = new Array(state.length).fill({ re: 0, im: 0 });
  for (let i = 0; i < state.length; i++) {
    const bit = (i >> (nQubits - target - 1)) & 1;
    for (let k = 0; k < 2; k++) {
      const j =
        (i & ~(1 << (nQubits - target - 1))) | (k << (nQubits - target - 1));
      newState[j] = {
        re: newState[j].re + gate[k][bit] * state[i].re,
        im: 0,
      };
    }
  }
  return newState;
};

export const applyCNOT = (state, control, target) => {
  const n = Math.log2(state.length);
  const result = new Array(state.length)
    .fill(null)
    .map(() => ({ re: 0, im: 0 }));

  for (let i = 0; i < state.length; i++) {
    const c = (i >> (n - control - 1)) & 1; // control bit
    if (c === 1) {
      // flip target bit
      const j = i ^ (1 << (n - target - 1));
      result[j] = state[i];
    } else {
      result[i] = state[i];
    }
  }
  return result;
};

export function applyCZ(state, control, target) {
  const n = Math.log2(state.length);
  if (!Number.isInteger(n))
    throw new Error("State length is not a power of two");

  const newState = state.map((amp, idx) => {
    // Determine bit values assuming qubit 0 is the most-significant bit (MSB).
    const ctrlBit = (idx >> (n - 1 - control)) & 1;
    const targBit = (idx >> (n - 1 - target)) & 1;
    if (ctrlBit === 1 && targBit === 1) {
      return { re: -amp.re, im: -amp.im };
    }
    return amp;
  });

  return newState;
}

// Swap qubits i and j in n-qubit state vector
export function swapQubits(state, nQubits, i, j) {
  const newState = [...state];
  for (let k = 0; k < state.length; k++) {
    const bits = k.toString(2).padStart(nQubits, "0").split("").map(Number);
    const swappedBits = [...bits];
    [swappedBits[i], swappedBits[j]] = [swappedBits[j], swappedBits[i]];
    const newIndex = parseInt(swappedBits.join(""), 2);
    newState[newIndex] = state[k];
  }
  return newState;
}

export const measureProbabilities = (state) =>
  state.map((s) => s.re * s.re + (s.im || 0) * (s.im || 0));

// export const blochVector = ([a, b]) => {
//   const alpha = a.re,
//     beta = b.re;
//   return [2 * alpha * beta, 0, alpha * alpha - beta * beta];
// };


export function blochVector([a, b]) {
  const x = 2 * (a.re * b.re + a.im * b.im);
  const y = 2 * (a.re * b.im - a.im * b.re);
  const z = a.re * a.re + a.im * a.im - (b.re * b.re + b.im * b.im);

  // For numerical stability
  return [x || 0, y || 0, z || 0];
}


// Add at the bottom of utils/quantum.js
export function jointProbabilities(state) {
  // squared magnitude of each amplitude
  return state.map((a) => a.re * a.re + a.im * a.im);
}

export const Y = [
  [
    { re: 0, im: 0 },
    { re: 0, im: -1 },
  ],
  [
    { re: 0, im: 1 },
    { re: 0, im: 0 },
  ],
];

export const Z = [
  [
    { re: 1, im: 0 },
    { re: 0, im: 0 },
  ],
  [
    { re: 0, im: 0 },
    { re: -1, im: 0 },
  ],
];

export const S = [
  [
    { re: 1, im: 0 },
    { re: 0, im: 0 },
  ],
  [
    { re: 0, im: 0 },
    { re: 0, im: 1 },
  ],
];

export const T = [
  [
    { re: 1, im: 0 },
    { re: 0, im: 0 },
  ],
  [
    { re: 0, im: 0 },
    { re: Math.sqrt(0.5), im: Math.sqrt(0.5) },
  ],
];
